import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import * as moment from 'moment';
import {CONFIG_ENV} from '@/config';
import DialogOpenScan from '@/components/DialogOpenScan/DialogOpenScan.vue';
import nomenclatoare from '@/store/nomenclatoare';
import iDocument from '@/types/iDocument';
import iScan from '@/types/iScan';
import {dateToStringDDMonYYYY} from '@/modules/utils';
import {humanReadableBytes} from '@/modules/utils';
import {ServicesDocument} from '@/modules/ServicesDocument';
type OrNull<T> = { [K in keyof T]: T[K] | null }
type IDocument = OrNull<iDocument>;

interface IDocumentComplet extends IDocument{
  scans:iScan[]
}

@Component({components: {DialogOpenScan}})
export default class MyDocuments extends Vue {
  public taburi: string='documente_repartizate';
  public filter: string = '';
  public $refs: any;
  public loadingData: boolean = false;
  public showPreviewFileDialog: boolean =false;
  public tableDataMyDocuments: IDocument[] = [];
  private storeNomenclatoare = getModule(nomenclatoare);
  // private userStore=getModule(User);
  public myPagination:any={
    rowsPerPage:10
  }
  public visibleColumns: string[] = [ 'nr_inreg', 'data_inreg', 'id_tip_doc', 'tip_request', 'nume_denumire','scans', 'appid'];
  public  columns: any = [
    { name: 'nr_inreg', label: 'Nr.document', field: 'nr_inreg', align: 'left', sortable: true, sort: (a: string, b: string) => parseInt(a, 10) - parseInt(b, 10) },
    { name: 'data_inreg', label: 'Data document', field: 'data_inreg', align: 'left', sortable: true },
    { name: 'id_tip_doc', label: 'Tip document', field: 'id_tip_doc', align: 'left', sortable: true },
    { name: 'tip_request', label: 'Tip corespondenta', field: 'tip_request', align: 'left', sortable: true },
    { name: 'nume_denumire', label: 'Denumire solicitant', field: 'nume_denumire', align: 'left', sortable: true },
    { name: 'scans', label: 'Documente atasate', field: 'scans', align: 'left' },
    { name: 'appid', label: 'Actiuni', field: 'appid' }
    ];

  constructor() {
    super();
  }

  askIfDeleteThis(pdocument: iDocument){
    this.$q.notify({
      color: 'red',
      textColor: 'white',
      type: 'negative',
      message: 'se va deschide dialog pentru actiuni',
      position: 'top-right',
      timeout: 3500,
    });
  }

  public openWorkOnDocument(pdocument: iDocument){
    const vueInst = this;
    vueInst.$emit('MyDocuments', {action:'openDocument',value:pdocument.appid})
  }

  public humanReadableBytes(nrPfBytes:number): string{
    return humanReadableBytes(nrPfBytes);
  }

  public openPreviewForm(pappid: number){
    const vueInst = this;
    //@ts-ignore;
    vueInst.$eventHub.$emit('eventFromChildComponent',{action:'show_preview_file',scan_appid:pappid});
  }

  public getMyDocuments(){
    const vueInst = this;
    ServicesDocument.getMyDocuments().then(presponse =>{
      vueInst.loadingData=false;
      if(presponse.status == 'success'){
        vueInst.tableDataMyDocuments=JSON.parse(JSON.stringify(presponse.rows));
        vueInst.$emit('MyDocuments', {action:'updateNrOfMyDocuments',value:vueInst.tableDataMyDocuments.length})
      }
    })
  }

  public getDenTipDocument(pIdTipDoc: number): string{
    const vueInst=this;
    let result='';
    const TipDoc = vueInst.storeNomenclatoare.NomTipDoc.find( tipdoc =>{
      return tipdoc.id_tip_doc == pIdTipDoc;
    });
    if(TipDoc){
      result=TipDoc.den_lang_1;
    }
    return result;
  }

  public mounted() {
    this.loadingData=true;
    this.storeNomenclatoare.set_currentpagetitle('Documentele repartizate');
    this.getMyDocuments();
  }
}
